/**
 * list of parameters
 * @param {is visa checkout authorization enabled for site} enabled
 * @param {visa checkout apikey} apikey
 * @param {visa checkout api domain} visaApiDomain
 * @param {api method for authorize customer} apiAuthRequest
 */
var VisaCheckoutAuthorization = (function ($) {

	function getVisaCheckoutReadyFunc(apiKey, callback) {
		return function () {
            V.init({
                apikey: apiKey,
                settings: {
                    shipping: {
                        collectShipping: 'false'
                    },
                }
            });
			V.on("payment.success", callback);
		};
	}

	function VisaCheckoutAuthorization(options) {
		this.enabled = options.enabled;
		this.apikey = options.apikey;
		this.visaApiDomain = options.visaApiDomain.replace(/\/$/, '');
		this.authCallback = options.authCallback;

		if (this.enabled) {
			this._init();
		} else {
			$('.v-button').remove();
		}
	}

	VisaCheckoutAuthorization.prototype = 
	{
		_init: function() {
			if (this.enabled) {
                visa_checkout_instance.init(this.visaApiDomain, getVisaCheckoutReadyFunc(this.apikey, this.authCallback));
            }
		}
	}

	return VisaCheckoutAuthorization;

})(jQuery);